import FilterPagesGeneral from "../../components/FilterPagesGeneral";

export default function MyRequests() {
  const filterMethods = ["range_types"];
  const buttons = ["export_report", "start_request"];

  return (
    <FilterPagesGeneral
      pageName={"partner_requests"}
      filterMethods={filterMethods}
      buttonTypes={buttons}
    />
  );
}
